<template>
  <div>
    <v-toolbar flat color="primary" dark>
      <v-toolbar-title>Current Batches</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <template>
        <v-btn outline dark class="mb-2" @click="showAddBatchForm"
          >Add Batch</v-btn
        >
      </template>
    </v-toolbar>

    <v-progress-linear
      slot="progress"
      color="primary"
      height="4"
      indeterminate
      v-show="progressBar"
    ></v-progress-linear>

    <template v-if="!progressBar">
      <batch-form
        v-show="isNewBatchForm"
        :isFormEnabled="isNewBatchForm"
        :model="emptyModel"
        formContext="add"
        v-on:batchFormCancelEvent="onBatchDialogFormCancel"
        v-on:batchFormAddEvent="onBatchDialogFormSave"
      ></batch-form>
    </template>

    <v-card>
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <v-flex v-for="batch in batches" :key="batch.Id" xs6>
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 12 : 2}`"
              >
                <v-img
                  src="https://cdn.vuetifyjs.com/images/cards/sunshine.jpg"
                  height="200px"
                >
                </v-img>
                <v-card-title primary-title>
                  <div>
                    <div class="headline">
                      {{ batch.ServicesOffered[0] }} - {{ batch.Name }}
                    </div>
                    <span class="grey--text">{{ batch.Center }}</span>
                  </div>
                </v-card-title>
                <v-card-text>
                  <div class="body-2">Number of Students</div>
                  <div class="body-1">
                    {{ batch.NoOfStudents > 0 ? batch.NoOfStudents : 0 }}
                  </div>
                </v-card-text>
                <v-card-text>
                  <div class="body-2">Batch Duration</div>
                  <div class="body-1">
                    {{ batch.StartDate }} - {{ batch.EndDate }}
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    outline
                    color="purple"
                    @click="getBatchDetails(batch.Id)"
                    >STUDENTS LIST</v-btn
                  >
                  <v-btn depressed color="error" @click="closeBatch(batch.Id)"
                    >Close</v-btn
                  >
                  <v-spacer></v-spacer>
                  <v-btn icon @click="showBatchDetails = !showBatchDetails">
                    <v-icon>{{
                      showBatchDetails
                        ? "keyboard_arrow_down"
                        : "keyboard_arrow_up"
                    }}</v-icon>
                  </v-btn>
                </v-card-actions>
                <v-slide-y-transition>
                  <v-card-text v-show="showBatchDetails">
                    <!-- //#TODO Show Batch Progress Details -->
                    <!--                 <v-flex xs12>
                  <v-card-text>
                    <v-list
                      dense
                      v-for="(value, propertyName, index) in batch"
                      :key="index"
                    >
                      <v-list-tile>
                        <v-list-tile-content>{{ propertyName }} : {{ value }}</v-list-tile-content>
                         <v-list-tile-content class="align-end">{{
                          batch[value]
                        }}</v-list-tile-content>
                   </v-list-tile>
                    </v-list>
                  </v-card-text>
                </v-flex> -->
                  </v-card-text>
                </v-slide-y-transition>
              </v-card>
            </v-hover>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

    <v-dialog v-model="closeBatchDialog" max-width="290">
      <v-card>
        <v-card-title class="headline"
          >Do you want to close Batch?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            flat="flat"
            @click="closeBatchDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="green darken-1" flat="flat" @click="remove()"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BatchForm from "./BatchForm";
import dbStore from "../db/dbStore";
import { mapMutations, mapGetters } from "vuex";

export default {
  name: "Batch",
  components: {
    BatchForm
  },
  data: function() {
    return {
      showBatchDetails: false,
      progressBar: false,
      search: "",
      pagination: {
        sortBy: "name"
      },
      isNewBatchForm: false,
      closeBatchDialog: false,
      selected: [],
      centers: [],
      emptyModel: {
        Id: "",
        Name: "",
        StartDate: "",
        EndDate: "",
        NoOfStudents: "",
        Students: "",
        CenterId: "",
        ServiceId: ""
      },
      batches: []
    };
  },
  created() {
    this.$store.commit("_home");
    this.getData();
  },
  computed: {
    login_details: function() {
      return this.$store.getters.get_login_details;
    }
  },
  methods: {
    async getData() {
      this.progressBar = true;
      dbStore.setCollectionName("batches");
      this.batches = await dbStore.getItems();
      var filter = { Field: "Status", Operator: "!=", Value: "Closed" };
      this.batches = this.filterItems(this.batches, filter);
      dbStore.setCollectionName("centers");
      this.centers = await dbStore.getItems();
      this.batches = await this.getBatchesForCurrentCenter(this.batches)
      this.mapBatchesWithCenters(this.centers, this.batches);
      this.progressBar = false;
    },

    filterItems(items, filter) {
      var temp = [];
      items.forEach(element => {
        if (element[filter.Field]) {
          var statement =
            '"' +
            element[filter.Field] +
            '"' +
            filter.Operator +
            '"' +
            filter.Value +
            '"';
          if (eval(statement)) {
            temp.push(element);
          }
        } else {
          temp.push(element);
        }
      });
      return temp;
    },

    async mapBatchesWithCenters(centers, batches) {
      await batches.forEach(async batch => {
        await centers.forEach(async center => {
          if (center.Id == Number(batch.CenterId)) {
            batch.Center = center.name;
          }
        });
      });
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    showAddBatchForm() {
      this.isNewBatchForm = true;
    },

    onBatchDialogFormCancel(value) {
      //console.log(value);
      if (value) {
        this.isNewBatchForm = false;
      }
    },

    onBatchDialogFormSave(value) {
      if (value) {
        this.isNewBatchForm = false;
        this.getData();
      }
    },

    getBatchDetails(Id) {
      //console.log(Id)
      this.$router.push({
        name: "batch",
        params: {
          id: Id
        }
      });
    },

    async remove() {
      var json = { Status: "Closed" };
      dbStore.setCollectionName("batches");
      var response = await dbStore.updateItemProperty(this.closeBatchId, json);
      if (response.isStateChanged) {
        this.closeBatchDialog = false;
        this.getData();
      }
    },

    closeBatch(Id) {
      //console.log(Id)
      this.closeBatchId = Id;
      this.closeBatchDialog = true;
    },

    async getBatchesForCurrentCenter(batches) {
      var temp = []
      var centerId = this.login_details.centerId
      await batches.forEach(async batch => {
        if(centerId == 0 || batch.CenterId === centerId) {
          temp.push(batch)
        }
      });
      return temp
    },

    ...mapMutations([
      "_login_details"
    ])
  }
};
</script>
